import { TAttachmentActions } from './attachment.actions';
import { ATTACHMENT_DEFAULT_PAGINATION_OPTION, TAttachmentActionTypes, TAttachmentState } from './attachment.model';

export const initialState: TAttachmentState = {
  attachmentApprovalsListing: null,
  attachmentListing: null,
  attachmentListingPagination: ATTACHMENT_DEFAULT_PAGINATION_OPTION,
  attachmentListingSearchStr: '',
};

export function attachmentReducer(state = initialState, action: TAttachmentActions): TAttachmentState {
  switch (action.type) {
    case TAttachmentActionTypes.FetchAttachmentListSuccess:
      return { ...state, attachmentListing: action.payload };

    case TAttachmentActionTypes.SetAttachmentListingPaginationOption:
      return { ...state, attachmentListingPagination: action.payload };

    case TAttachmentActionTypes.SetAttachmentListingSearchStr:
      return { ...state, attachmentListingSearchStr: action.payload };

    case TAttachmentActionTypes.FetchAttachmentApprovalListSuccess:
      return { ...state, attachmentApprovalsListing: action.payload };

    default:
      return state;
  }
}
